module.exports = "<div class=\"modal-header\">\n  <h3 class=\"modal-title\" id=\"modal-title\">Add / Edit Tags</h3>\n</div>\n<div class=\"modal-body\" id=\"modal-body\">\n\n  <!-- Tags -->\n  <div class=\"form-group\">\n    <label>Tags</label>\n    <tags-input ng-model=\"$ctrl.asset.tags\"></tags-input>\n  </div>\n\n</div>\n<div class=\"modal-footer\">\n  <button class=\"btn btn-primary\" type=\"button\" ng-click=\"$ctrl.ok()\">Save</button>\n  <button class=\"btn btn-warning\" type=\"button\" ng-click=\"$ctrl.cancel()\">Cancel</button>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./client/~sm/components/asset/tags/asset-tags.component.html
// module id = 934
// module chunks = 0